"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var severities = ['critical', 'problem', 'info', 'good'];
// TO DO test bounding boxes when media gallery is merged
function Notices(_a) {
    var notices = _a.notices, generatedNotices = _a.generatedNotices, hideMainIcon = _a.hideMainIcon, triggerNoticeBoundingBoxes = _a.triggerNoticeBoundingBoxes;
    var sortedNotices = notices === null || notices === void 0 ? void 0 : notices.sort(function (a, b) { return severities.indexOf(b.severity) - severities.indexOf(a.severity); });
    var handleClick = function (notice) {
        var newNotice = __assign(__assign({}, notice), { lockInShowBoundingBoxes: !notice.lockInShowBoundingBoxes, showBoundingBoxes: !notice.lockInShowBoundingBoxes });
        triggerNoticeBoundingBoxes(notice.id, newNotice);
    };
    var handleMouseEnter = function (notice) {
        if (notice.lockInShowBoundingBoxes) {
            return;
        }
        var newNotice = __assign(__assign({}, notice), { showBoundingBoxes: true });
        triggerNoticeBoundingBoxes(notice.id, newNotice);
    };
    var handleMouseLeave = function (notice) {
        if (notice.lockInShowBoundingBoxes) {
            return;
        }
        var newNotice = __assign(__assign({}, notice), { showBoundingBoxes: false });
        triggerNoticeBoundingBoxes(notice.id, newNotice);
    };
    return (react_1.default.createElement("div", { className: "eva-notice-container" },
        !hideMainIcon && react_1.default.createElement("i", { className: "eva-notice-icon implioicons-notifications" }),
        react_1.default.createElement("div", { className: "notice-container" }, sortedNotices === null || sortedNotices === void 0 ? void 0 :
            sortedNotices.map(function (notice, index) { return (react_1.default.createElement("div", { key: index, className: "eva-notice notice-".concat(notice.severity) },
                react_1.default.createElement("i", { className: "implio-notice-icon" }),
                react_1.default.createElement("span", { className: "notice-message", title: notice.message }, notice.message))); }), generatedNotices === null || generatedNotices === void 0 ? void 0 :
            generatedNotices.map(function (notice, index) { return (react_1.default.createElement("div", { key: index, className: "eva-notice eva-generated-notice eva-generated-notice-hover ".concat(notice.lockInShowBoundingBoxes ? 'active-generated-notices' : ''), onClick: function () { return handleClick(notice); }, onMouseEnter: function () { return handleMouseEnter(notice); }, onMouseLeave: function () { return handleMouseLeave(notice); } },
                react_1.default.createElement("i", { className: "implioicons-bounding-box implio-notice-icon" }),
                react_1.default.createElement("span", { className: "notice-message" }, notice.message))); }))));
}
exports.default = Notices;
